import { createRequestActions } from "common/helpers/action";

export const initCpUsersList = createRequestActions("CP.USERS.LIST.INIT");
export const scrollCpUsersList = createRequestActions("CP.USERS.LIST.SCROLL");
export const searchCpUsersList = createRequestActions("CP.USERS.LIST.SEARCH");
